interface PaginationProps {
  page: number
  totalPages: number
  totalItems: number
  pageSize: number
  onPageChange: (page: number) => void
}

export function Pagination({ page, totalPages, totalItems, pageSize, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null

  const start = (page - 1) * pageSize + 1
  const end = Math.min(page * pageSize, totalItems)

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 16px',
      borderTop: '1px solid var(--s100)',
      fontSize: '13px',
      color: 'var(--s500)',
    }}>
      <span>Showing {start}–{end} of {totalItems}</span>
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          style={{
            padding: '5px 12px',
            border: '1px solid var(--s200)',
            borderRadius: '6px',
            background: page === 1 ? 'var(--s50)' : '#fff',
            color: page === 1 ? 'var(--s300)' : 'var(--s700)',
            cursor: page === 1 ? 'default' : 'pointer',
            fontSize: '13px',
            fontWeight: 500,
          }}
        >
          ← Prev
        </button>
        <span style={{ padding: '0 8px', color: 'var(--s600)', fontWeight: 500 }}>
          {page} / {totalPages}
        </span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          style={{
            padding: '5px 12px',
            border: '1px solid var(--s200)',
            borderRadius: '6px',
            background: page === totalPages ? 'var(--s50)' : '#fff',
            color: page === totalPages ? 'var(--s300)' : 'var(--s700)',
            cursor: page === totalPages ? 'default' : 'pointer',
            fontSize: '13px',
            fontWeight: 500,
          }}
        >
          Next →
        </button>
      </div>
    </div>
  )
}
